import type { Product } from '@tagadapay/crm-entities';

import type { ProductImageGalleryItem } from '@/components/products/ProductImageLightbox';

export const buildProductImageGallery = (products: Product.Product[]): ProductImageGalleryItem[] =>
  products
    .filter((product) => Boolean(product.image))
    .map((product) => ({
      id: product.id,
      url: product.image as string,
      alt: product.name,
    }));

export const galleryIndexForProduct = (items: ProductImageGalleryItem[], productId: string) =>
  items.findIndex((item) => item.id === productId);
